<div class="wrap">
  <div class="lnb">
    <a routerLink="/main" class="top-logo">
      <img src="/assets/images/logo_stat.png" alt="로고" />
    </a>
    <ul class="menu">
      <li class="nav-item"><a class="cp" [ngClass]="{active: tabIndex==0}" (click)="tabIndex=0">년도별 생산/출하</a></li>
      <li class="nav-item"><a class="cp" [ngClass]="{active: tabIndex==1}" (click)="tabIndex=1">품목별 생산/출하</a></li>
      <li class="nav-item"><a class="cp" [ngClass]="{active: tabIndex==2}" (click)="tabIndex=2">년도별 수출입 통계</a></li>
      <li class="nav-item"><a class="cp" [ngClass]="{active: tabIndex==3}" (click)="tabIndex=3">월별 수출입 통계</a></li>
    </ul>
  </div>

  <div class="tab-content">
    <div *ngIf="tabIndex==0" class="tab-pane" [ngClass]="{show: tabIndex==0, active: tabIndex==0, fadeIn: tabIndex==0, fade: tabIndex!==0}">
      <app-statistics-pg1></app-statistics-pg1>
    </div>
    <div *ngIf="tabIndex==1" class="tab-pane" [ngClass]="{show: tabIndex==1, active: tabIndex==1, fadeIn: tabIndex==1, fade: tabIndex!==1}">
      <app-statistics-pg2></app-statistics-pg2>
    </div>
    <div *ngIf="tabIndex==2" class="tab-pane" [ngClass]="{show: tabIndex==2, active: tabIndex==2, fadeIn: tabIndex==2, fade: tabIndex!==2}">
      <app-statistics-pg3></app-statistics-pg3>
    </div>
    <div *ngIf="tabIndex==3" class="tab-pane" [ngClass]="{show: tabIndex==3, active: tabIndex==3, fadeIn: tabIndex==3, fade: tabIndex!==3}">
      <app-statistics-pg4></app-statistics-pg4>
    </div>
  </div>
</div>



